import controller from './thing-details-folder.controller';

const template = require('./thing-details-folder.html');

export default {
    bindings: {
        folderId: '<',
        onUpdate: '&'
    },

    template,
    controller
};




// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-details-folder/thing-details-folder.component.js